const t = (o) => Math.floor(Math.random() * o);
export {
  t as randomInt
};
//# sourceMappingURL=index2.js.map
